import { useState } from "react";
import { Input } from "./input";
import { cn } from "@/lib/class-control";
import { Eye, EyeOff } from "lucide-react";
import { ControllerRenderProps, FieldValues } from "react-hook-form";

export function InputPassword<T extends FieldValues>({ field, placeholder }: { field: ControllerRenderProps<T>, placeholder: string }) {

  const [show, setShow] = useState(false);

  return (
    <Input type={show ? "text" : "password"} placeholder={placeholder} {...field}
      end={<EndComponent show={show} setShow={setShow} isInputEmpty={field.value === ""} />} />
  );
}

const EndComponent = ({ isInputEmpty, show, setShow }: { isInputEmpty: boolean, show: boolean, setShow: React.Dispatch<React.SetStateAction<boolean>> }) => {
  return (
    <div className={cn("flex ml-1.5 text-gray-300 hover:text-white cursor-pointer", { "pointer-events-none": isInputEmpty })}>
      <button
        type="button"
        onClick={() => setShow((prev) => !prev)}
        tabIndex={-1}
        aria-label={show ? "Ocultar senha" : "Mostrar senha"}
      >
        {show ? <EyeOff size={16} /> : <Eye size={16} />}
      </button>
    </div>
  )
}
